import { useState, useMemo, useEffect } from "react";

import {
  Dialog,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../common/dialog";

import { Call } from "./SingleContact/Call";
import { Sms } from "./SingleContact/SMS";
import { WhatsApp } from "./SingleContact/WhatsAppV2";
import InputComponent from "V2.0/components/InputComponent";
import { useAssistants } from "V2.0/HomePages/Assistants";
import { useAssistantOptions } from "./useAssistantOptions";
import { useAssistantPhoneNumbers } from "./useAssistantPhoneNumbers";
import IgnorePreviousCampaigns, {
  useIgnorePreviousCampaigns,
} from "./common/Fields/IgnorePreviousCampaigns";

export const CAMPAIGN_TYPE = {
  SMS: "sms",
  CALL: "call",
  WHATSAPP: "whatsapp",
};

export const Campaign_Type_Label = {
  sms: "Sms",
  call: "Call",
  whatsapp: "WhatsApp",
};

const ASSISTANT_CAMPAIGN_MAPPING = {
  [CAMPAIGN_TYPE.SMS]: "sms",
  [CAMPAIGN_TYPE.CALL]: "voice",
  [CAMPAIGN_TYPE.WHATSAPP]: "whatsapp",
};

const CampaignAddRegistry = {
  [CAMPAIGN_TYPE.SMS]: (props) => <Sms {...props} />,
  [CAMPAIGN_TYPE.CALL]: (props) => <Call {...props} />,
  [CAMPAIGN_TYPE.WHATSAPP]: (props) => <WhatsApp {...props} />,
};

export function SingleCampaignAdd(props) {
  const { addUserToCampaign, dialogState, onClose, projectId, campaignType } =
    props;
  const { assistants, fetchAssistants } = useAssistants(projectId);
  const { assistantOptions, assistantId, setAssistantId } = useAssistantOptions(
    assistants,
    campaignType
  );
  const { fromNumber, setFromNumber, phoneNumbers } = useAssistantPhoneNumbers(
    assistantId,
    projectId
  );
  const { isIgnorePreviousCampaigns, toggleIgnorePreviousCampaigns } =
    useIgnorePreviousCampaigns();

  useEffect(() => {
    if (projectId) {
      fetchAssistants();
    }
  }, [projectId]);

  return (
    <Dialog
      open={dialogState.isOpen}
      onClose={onClose}
      size="lg"
    >
      <DialogTitle>
        Single {Campaign_Type_Label[campaignType]} Campaign
      </DialogTitle>
      <DialogBody>
        {/* <InputComponent
          label="Campaign type"
          type="select"
          options={[
            { id: 1, label: CAMPAIGN_TYPE.SMS, value: CAMPAIGN_TYPE.SMS },
            { id: 2, label: CAMPAIGN_TYPE.CALL, value: CAMPAIGN_TYPE.CALL },
            {
              id: 2,
              label: CAMPAIGN_TYPE.WHATSAPP,
              value: CAMPAIGN_TYPE.WHATSAPP,
            },
          ]}
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
        /> */}
        <InputComponent
          label="Assistant"
          type="select"
          options={assistantOptions}
          value={assistantId}
          onChange={(e) => setAssistantId(e.target.value)}
        />
        <InputComponent
          label="From Number"
          type="select"
          options={phoneNumbers}
          value={fromNumber}
          onChange={(e) => setFromNumber(e.target.value)}
        />

        <IgnorePreviousCampaigns
          isIgnored={isIgnorePreviousCampaigns}
          onToggleIgnore={toggleIgnorePreviousCampaigns}
        />

        {CampaignAddRegistry[campaignType]({
          addUserToCampaign,
          onClose,
          projectId,
          assistantId,
          fromNumber,
          ignorePreviousCampaigns: isIgnorePreviousCampaigns,
        })}
      </DialogBody>
    </Dialog>
  );
}
